import React from 'react';
import { Edit } from '@saleshandy/icons';

const EditNote = () => (
  <Edit className="orange-txt-16" />
);

export default EditNote;
